import { render, staticRenderFns } from "./number-input.vue?vue&type=template&id=45c9b5a0&scoped=true&"
import script from "./number-input.vue?vue&type=script&lang=js&"
export * from "./number-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9b5a0",
  null
  
)

export default component.exports